<div class="sidebar-container">
  <div class="section">
    @if (!loadCompany) {
      @if (entity !== null) {
        <div>
          <app-ag-tag-entity-title
            [isLink]="true"
            [entity]="entity"
            [entityType]="entityType"
          />
        </div>
      }

      <div class="document-info-grid">
        <div class="info-item">
          <div class="info-item-title">Status</div>
          <div class="status-wrapper">
            <app-ag-annual-status [status]="annual?.annualStatementStatus"/>
          </div>
        </div>

        <div class="info-item">
          <div class="info-item-title">Debt</div>
          <div class="info-item-content">
            {{ annual?.company?.companyDebt?.amountOwing| currency : "$" : 'code' : '1.2-2'| replaceStr: '-': 'CR ' }}
          </div>
        </div>

        <div class="info-item">
          <div class="info-item-title">Signing Status</div>
          <app-ag-document-signing-status [status]="annual?.documentSigning?.signingStatus!"/>
        </div>

        <div class="info-item">
          <div class="info-item-title">Review Date</div>
          <div class="info-item-content">{{ annual?.reviewDate | date: 'dd MMM yyyy' }}</div>
        </div>

        <div class="info-item">
          <div class="info-item-title">Payment Deadline</div>
          <div class="info-item-content">
            {{ annual?.paymentDeadline ? (annual?.paymentDeadline | date : 'dd MMM yyyy') : 'N/A' }}
          </div>
        </div>
      </div>

      <div class="tag-container">
        <div class="info-item-title">Tags</div>
        <div class="info-item-tag">
          @for (tag of entity?.tags; track tag) {
            <app-tag [tag]="tag"/>
          } @empty {
            -
          }
        </div>
      </div>
    } @else {
      <div class="skeleton-container">
        <ngx-skeleton-loader count="2" appearance="line"/>
        <div class="d-flex gap-12">
          <ngx-skeleton-loader style="width: 50%" count="5" appearance="line"/>
          <ngx-skeleton-loader style="width: 50%" count="5" appearance="line"/>
        </div>
      </div>
    }
  </div>

  @if (!loading && !loadCompany) {
    <div class="section">
      @if (currentStepIndex === AnnualStep.SignDocuments && documentsList?.final?.length) {
        <div class="documents-container">
          <div class="d-flex justify-content-between align-items-center">
            <div class="title-wrapper d-flex gap-12">
              <div>
                <i class="icon ic-documents-20"></i>
              </div>

              <div class="title font-size-16">Documents</div>
            </div>

            <div
              ngbDropdown
              class="dropdown"
              [placement]="['bottom-end', 'bottom-start', 'top-start', 'top-end']"
            >
              <app-button
                ngbDropdownToggle
                [btnColor]="'white'"
                [iconClass]="'icon ic-download-20'"
              />
              <div ngbDropdownMenu class="common-dropdown-menu dropdown-menu dropdown-menu-right">
                <div ngbDropdownItem (click)="downloadCombinedPDF(DocumentSubFolderName.Final)">
                  <span>Download combined PDF</span>
                </div>

                <div ngbDropdownItem (click)="downloadZIP(DocumentSubFolderName.Final)">
                  <span>Download ZIP</span>
                </div>
              </div>
            </div>
          </div>

          <div class="generated-docs">
            <app-documents-list-accordion
              label="Generated"
              noDocsPlaceholder="No generated documents"
              [initialClosed]="false"
              [hideDeleteBtn]="true"
              [documents]="documentsList?.final ?? null"
              (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Final)"
            />
          </div>

          @if (documentsList?.signed?.length) {
            <div class="signed-docs">
              <app-documents-list-accordion
                label="Signed"
                noDocsPlaceholder="No signed documents"
                [hideDeleteBtn]="true"
                [documents]="documentsList?.signed ?? null"
                (downloadFile)="downloadFile($event.name, DocumentSubFolderName.Signed)"
              />
            </div>
          }

          @if (annual?.documentSigning?.signingStatus === SigningStatus.ReadyToSend) {
            <div class="document-uploaded-container">
              <div class="uploaded-container">
                <div class="d-flex align-items-center font-size-12 line-height-16 font-weight-bold">
                  Documents to Attach

                  <i
                    class="ml-2 icon ic-info-circle-16"
                    placement="top-left"
                    tooltipClass="tooltip-info"
                    [ngbTooltip]="documentsToAttachInfo"
                  ></i>
                </div>
                <div class="uploaded-list">
                  @for (document of documentsToAttach; track $index) {
                    <div class="document">
                      <app-checkbox
                        labelIconClass="icon ic-file-16"
                        [label]="document.documentName"
                        (change)="selectAttachedDocument($event, $index)"
                      />
                    </div>
                  } @empty {
                    <div class="font-size-12">No Documents to Attach</div>
                  }
                </div>
              </div>
            </div>
          }

          <div class="uploaded-container">
            <app-documents-list-accordion
              label="Uploaded"
              noDocsPlaceholder="No uploaded files"
              [tip]="filesToAttachInfo"
              [initialClosed]="!documentsList?.attached?.length"
              [documents]="documentsList?.attached ?? null"
              [hideDeleteBtn]="annual?.documentSigning?.signingStatus !== SigningStatus.ReadyToSend"
              (downloadFile)="downloadFile($event.name, DocumentSubFolderName.FileAttached)"
              (deleteFile)="deleteFile($event.name, DocumentSubFolderName.FileAttached)"
            />

            @if (annual?.documentSigning?.signingStatus === SigningStatus.ReadyToSend) {
              <app-button
                class="upload-file mt-2"
                text="Upload File(s)"
                (clickBtn)="openUploadFileModal(DocumentSubFolderName.FileAttached)"
              />
            }
          </div>
        </div>
      }
    </div>
  } @else {
    @if (currentStepIndex) {
      <div class="section">
        <div class="skeleton-container">
          <ngx-skeleton-loader count="6" appearance="line"/>
        </div>
      </div>
    }
  }

  @if (!loading && !loadCompany) {
    @if (showRemindersSidebar) {
      <div class="section">
        <app-reminders-sidebar
          [reminders]="annual?.reminders"
          [documentBase]="annual ?? null"
          [paymentDeadline]="annual?.paymentDeadline"
          [showPaymentReminder]="showPaymentReminder"
        />
      </div>
    }
  } @else {
    @if (currentStepIndex) {
      <div class="section">
        <div class="skeleton-container">
          <ngx-skeleton-loader count="6" appearance="line"/>
        </div>
      </div>
    }
  }
</div>
